'use strict';

export default function documentScroll()
{
    // We need document.documentElement because IE doesn't support scrollingElement yet.
    const dse = document.scrollingElement || document.documentElement;
    return {
        top: window.pageYOffset || dse && dse.scrollTop,
        left: window.pageXOffset || dse && dse.scrollLeft
    };
};
